import { render, staticRenderFns } from "./RecordPickerTabs.vue?vue&type=template&id=772a5f7a&scoped=true&"
import script from "./RecordPickerTabs.vue?vue&type=script&lang=js&"
export * from "./RecordPickerTabs.vue?vue&type=script&lang=js&"
import style0 from "./RecordPickerTabs.vue?vue&type=style&index=0&id=772a5f7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772a5f7a",
  null
  
)

export default component.exports